import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container w-full mx-auto" }
const _hoisted_4 = { class: "relative w-full shadow-lg rounded-lg bg-white p-4" }
const _hoisted_5 = { class: "container mx-auto block w-full mt-4 space-y-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogoView = _resolveComponent("CatalogoView")!
  const _component_CommonPublicView = _resolveComponent("CommonPublicView")!

  return (_openBlock(), _createBlock(_component_CommonPublicView, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.evento)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.evento.descripcion), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " CATÁLOGO ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CatalogoView, { padding: false })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}